module.exports = __webpack_public_path__ + "static/media/Voyager-RE-4200.2e65e30b.jpg";